import { AccordionDetails } from "@mui/material";

export const MuiAccordionDetails = AccordionDetails;
